import classNames from 'classnames';
import { Field } from 'react-final-form';
import { RadioField } from 'components/Forms/RadioField';
import { TextField } from 'components/Forms/TextField';
import { useFieldValue } from 'hooks/useFormHelpers';

export const LocationForm = () => {
  const locationVisible = useFieldValue('is_location_visible');

  const locationVisibilityOptions = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No, hide the location' },
  ];

  return (
    <div className="row">
      <div className="col-md-8 padding0">
        <Field name="location_name">
          {({ meta }) => (
            <div
              className={classNames('form-group', {
                'has-danger': meta.error && locationVisible,
              })}
            >
              <TextField
                label="Location (optional)"
                name="location_name"
                type="text"
                disabled={!locationVisible}
                customErrorValidation={meta.error && locationVisible}
              />
            </div>
          )}
        </Field>
      </div>
      <div className="col-md-4 location-radios">
        <RadioField
          name="is_location_visible"
          label="Show location on event page?"
          options={locationVisibilityOptions}
          order="column"
        />
      </div>
    </div>
  );
};
